<div class="ng-modal-dialog">
  <div class="decision-dialog">
    <p class="text-center"><i class="icon ic-icon_meldung_hinweis"></i></p>
    <h1>Hinweis</h1>
    <h1  [innerHTML]="message | safeHtml"></h1>
    <div class="buttons clearfix">
        <ng-container *ngIf="!infoOnly">
            <app-custom-button color="primary" text="Ja" (click)="proceed(true)"><i class="fa fa-times"></i></app-custom-button>
            <app-custom-button color="primary" text="Nein" (click)="proceed(false)"><i class="fa fa-times"></i></app-custom-button>
        </ng-container>
        <ng-container *ngIf="infoOnly">
            <app-custom-button color="primary" text="Gelesen und weiter" (click)="processInfoOnly()"><i class="fa fa-times"></i></app-custom-button>
        </ng-container>
    </div>
    <div class="footer"></div>
  </div>
</div>
